import {
  Divider,
  Flex,
  type IconProps,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { Button, Delete as DeleteIcon, Icon } from '@mesh.ai/rabbit';
import { StyleCloseButton } from 'screens/oneOnOneRabbit/InstancePage/common/modals/ArchiveMeetingModal';

import { Cross } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { TextBodyMedium, TextHeader3 } from 'uiToolkitV1/Typography';

const CrossIcon = (props: IconProps) => <Cross {...props} boxSize="20px" />;

export const DeleteActionItemModal = ({ onClose, onConfirm }) => (
  <Modal isOpen onClose={onClose} isCentered>
    <ModalOverlay />
    <ModalContent maxH="204px" maxW={isMobileView() ? '300px' : '578px'}>
      <ModalHeader position="relative">
        <Flex gap="10px">
          <Icon IconSVG={DeleteIcon} />
          <TextHeader3 bold>Delete Action Item</TextHeader3>
        </Flex>
        <StyleCloseButton variant="filled" color="black" StartIcon={CrossIcon} onClick={onClose} />
      </ModalHeader>
      <Divider opacity={1} color="#EBEFF3" />
      <ModalBody p="26px 30px">
        <TextBodyMedium>Do you want to delete this action item?</TextBodyMedium>
      </ModalBody>
      <ModalFooter
        background="#F5F7F9"
        borderTop="1px solid #CED7DF"
        borderRadius="0px 0px 8px 8px"
        justifyContent="space-between"
      >
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onConfirm}>Yes</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
